import ForgotPasswordForm from '@/domains/auth/components/ForgotPasswordForm';

export default function ForgotPasswordPage() {
  return <ForgotPasswordForm />;
}
